import '../styles/Header.css';

const Header = () => {
    return; 
};

export default Header; 